import { FilterType, IGetFiltersDTO } from '@/models/filters.model';
import { TGetFiltersQuery } from '../helpers';

class GetFiltersDTO implements IGetFiltersDTO {
  title?: string;
  type?: FilterType;
  slug?: string;
  is_active?: number;
  page: number;
  limit?: number;
  categories?: string[];

  constructor({ title, type, slug, is_active, page, categories }: TGetFiltersQuery) {
    this.title = title;
    this.type = type;
    this.slug = slug;

    if (is_active !== undefined) {
      this.is_active = is_active ? 1 : 0;
    }
    this.page = page ?? 1;
    this.limit = 10;
    this.categories = categories;
  }
}

export default GetFiltersDTO;
